import { render } from "./FacturadorPOSView.vue?vue&type=template&id=4374ab8a&scoped=true"
import script from "./FacturadorPOSView.vue?vue&type=script&lang=js"
export * from "./FacturadorPOSView.vue?vue&type=script&lang=js"

import "./FacturadorPOSView.vue?vue&type=style&index=0&id=4374ab8a&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4374ab8a"]])

export default __exports__